import {ACTION_TYPE} from "utils/constants";

export const openAlert = ({alertType, props, options}) => ({
  type: ACTION_TYPE.OPEN_ALERT,
  alertType,
  props,
  options,
});

export const closeAlert = () => ({
  type: ACTION_TYPE.CLOSE_ALERT,
});
